<!-- Единая адаптивная группа кнопок и составных действий. -->
<template>
  <div
    class="base-button-actions"
    :class="`base-button-actions--align-${align}`"
    role="group"
    :aria-label="label"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "BaseButtonActions",

  props: {
    align: {
      type: String,
      default: "start",
      validator: (value) => ["start", "center", "end"].includes(value),
    },
    label: {
      type: String,
      default: "Действия",
    },
  },
};
</script>

<style scoped>
.base-button-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
}

.base-button-actions--align-center {
  justify-content: center;
}

.base-button-actions--align-end {
  justify-content: flex-end;
}

@media (max-width: 640px) {
  .base-button-actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    width: 100%;
  }

  .base-button-actions > :deep(*) {
    width: 100%;
    min-width: 0;
  }

  .base-button-actions :deep(.base-tooltip),
  .base-button-actions :deep(.btn),
  .base-button-actions :deep(.base-copy-button-text) {
    width: 100%;
    min-width: 0;
    min-height: 40px;
    height: auto;
    white-space: normal;
  }
}
</style>
